import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";
import MobileCTABar from "@/components/site/MobileCTABar";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import WhatIsWaterCremation from "@/pages/WhatIsWaterCremation";
import Benefits from "@/pages/Benefits";
import TheProcess from "@/pages/TheProcess";
import Providers from "@/pages/Providers";
import Faq from "@/pages/Faq";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import AdminListings from "@/pages/AdminListings";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  const reduce = useReducedMotion();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={reduce ? false : { opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={reduce ? { opacity: 1 } : { opacity: 0 }}
        transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/what-is-water-cremation" element={<WhatIsWaterCremation />} />
          <Route path="/benefits" element={<Benefits />} />
          <Route path="/the-process" element={<TheProcess />} />
          <Route path="/providers" element={<Providers />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:slug" element={<ArticleDetail />} />
          <Route path="/admin/listings" element={<AdminListings />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#F9F9F6] text-forest-900 pb-[76px] lg:pb-0">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <main data-testid="site-main">
          <AnimatedRoutes />
        </main>
        <Footer />
        <MobileCTABar />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
